<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'" :ariaLabel="$t('app.help_dialog_title')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('app.help_dialog_title')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
       <el-tabs tab-position="left" class="pt-2" style="height: inherit" ref="containertabs"  @tab-click="showBtnLicense">
        <el-tab-pane class="p-2 overflow-y-auto"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          tabIndex="0"
          >
           <span slot="label" class="flex items-center justify-start">
              <base-icon v-if="!mobileVersion" name="notes" size="xsm" class="mr-1" :ariaHidden="true"/> 
              <span>Notas de la versión</span>
            </span>
            <div class="block">
              <div v-for="(version, index) in dataPatchNotes" :key="version.title" class="mb-8">
                <h3 class="font-medium text-lg mb-2">
                  {{ version.title }} <span v-if="index === 0"> - Versión Actual</span>
                </h3>
                <p class="italic mb-2">
                  {{ version.date }}
                </p>
                <div v-for="cambio in version.changes" :key="cambio.title" class="mb-4">
                  <h4 class="font-medium mb-2">
                    {{ cambio.title }}
                  </h4>
                  <ul v-for="descripcion in cambio.description" :key="descripcion" class="mb-1">
                    <li>
                        • {{ descripcion }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-tab-pane>
        <el-tab-pane class="p-2 overflow-y-auto container-videos" name="academy"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          >
          <span slot="label" class="flex items-center justify-start">
            <base-icon v-if="!mobileVersion" name="videos" size="xsm" class="mr-1" :ariaHidden="true"/> 
            <span>{{$t('academy.title')}}</span>
          </span>
          <div class="block xl:grid xl:grid-cols-5 gap-x-2">
            <div class="mt-8 xl:col-span-2 pr-4 pl-4">
              <h3 class="font-bold text-lg mb-4">
                {{$t('academy.title')}}
              </h3>
              <p class="mt-4 text-balance">
                {{$t('academy.desc_1')}} <span class="font-bold">{{$t('academy.desc_2')}}</span>
              </p>
              <p class="mt-6">
                <base-button 
                  ariaLabel="Abrir Academy en una nueva ventana"
                  mode="primary" 
                  :text="$t('academy.button')" 
                  @click="goToAcademy" />
              </p>
            </div>
            <div class="hidden xl:block xl:col-span-3">
              <base-logo
                filename="academy.png"
                :alt="$t('academy.title')"
                :title="$t('academy.title')"
                class="brand rounded-md"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane class="p-2 overflow-y-auto"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          >
          <span slot="label" class="flex items-center justify-start">
            <base-icon v-if="!mobileVersion" name="manual" size="xsm" class="mr-1" :ariaHidden="true"/> 
            <span>Manuales de uso</span>
          </span>
          <div>
            <h3 class="font-medium text-lg mb-2">
              Manual de Usuario
            </h3>
            <div class="flex mb-2 items-center">
              <div class="w-full">
                <p>
                  Manual detallado con todas las funciones de la aplicación. Pulse
                  <button class="text-primary-800 cursor-pointer hover:text-primary-900 hover:bg-primary-100 dark:hover:bg-darkblue-600 rounded" 
                    @click="openManualUsuario"
                    :aria-label="$t('app.open_user_manual')"
                    tabIndex="0">aquí</button> 
                  para visualizarlo. 
                </p>
              </div>
              <base-button-icon
                ariaLabel="Descargar manual de usuario"
                @click="downloadManualUsuario"
                size="xs"
                name="download"
                class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full ml-2 mr-4"
              />
            </div>
          </div>

          <div v-if="role === 'SuperAdministrador' || role === 'SuperAdminDistribuidor' || role === 'AdminDistribuidor'">
            <h3 class="font-medium text-lg mb-2">
              Manual de Distribuidor y SuperAdministrador
            </h3>
            <div class="flex mb-2 items-center">
              <div class="w-full">
                <p>
                  Manual con todas las funciones exclusivas para usuarios distribuidores y con rol SuperAdministrador. Pulse
                  <button class="text-primary-800 cursor-pointer hover:text-primary-900 hover:bg-primary-100 dark:hover:bg-darkblue-600 rounded" 
                    @click="openManualDistribuidor"
                    :aria-label="$t('app.open_distributor_manual')"
                    tabIndex="0">aquí</button> 
                  para visualizarlo. 
                </p>
              </div>
              <base-button-icon
                ariaLabel="Descargar manual de distribuidor y superadministrador"
                @click="downloadManualDistribuidor"
                size="xs"
                name="download"
                class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full ml-2 mr-4"
              />
            </div>
          </div>

          <a href="/files/EdasNEO-Manual.pdf" download class="hidden" ref="downloadManualBtn"/>
          <a href="/files/EdasNEO-Manual-Distribuidor.pdf" download class="hidden" ref="downloadManualDistribuidorBtn"/>
        </el-tab-pane>
        <el-tab-pane class="p-2 overflow-y-auto"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          tabIndex="0"
          >
          <span slot="label" class="flex items-center justify-start">
            <base-icon v-if="!mobileVersion" name="contract" size="xsm" class="mr-1" :ariaHidden="true"/> 
            <span>Licencia de uso</span>
          </span>
          <h3 class="font-bold text-lg mb-6">
            {{$t('app.license_dialog_title')}}
          </h3>
          <LicenseContent/>
        </el-tab-pane>
        <el-tab-pane class="p-2 overflow-y-auto"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          tabIndex="0"
          >
          <span slot="label" class="flex items-center justify-start">
            <base-icon v-if="!mobileVersion" name="accessible" size="sm" class="" :ariaHidden="true"/> 
            <span>{{$t('app.accessibility')}}</span>
          </span>
          <h3 class="font-bold text-lg mb-6">
            {{$t('app.accessibility_dialog_title')}}
          </h3>
          <AccesibilityContent/>
        </el-tab-pane>
      </el-tabs>
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
          </div>
      </el-form>
    </template>
    <template slot="footer">
      <div class="w-full items-end justify-end flex space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <base-button v-if="btnLicense" @click="downloadLicense" mode="secondary-phantom-blue" :text="$t('app.download')"/>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.close')" />
          <a href="/files/EdasNEO-Licencia-uso.pdf" download class="hidden" ref="downloadLicense"/>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import LicenseContent from '@/components/license/LicenseContent.vue'
import AccesibilityContent from '@/components/license/AccesibilityContent.vue'
import { PATCH_NOTES } from '@/config/dynamic/patch-notes'
import { getVideos } from '@/services/config/getVideos.js'
import { isAiEnabled } from '@/config/runtimeConfig'

export default
{
  name: 'help-dialog',
  components: {
    BaseDialogButton,
    LicenseContent,
    AccesibilityContent,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.getVideos()
        setTimeout(() => {
          if (isAiEnabled()) {
            this.$store.commit('app/setshowButtonChatbot', true)
          }
        }, 1000)
      } 
    }
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      isLoadedData: false,
      dataPatchNotes: PATCH_NOTES,
      btnLicense: false,
      urlAcademy: 'https://academy.edasneo.com/',
      videoIds: [
        // {
        //   id: 1,
        //   Titulo: 'Vídeo de ayuda 1',
        //   Src: '/videos/help-01.mp4',
        //   CaptionsSrc: '/videos/help-01-captions-es.vtt',
        //   DescripcionsSrc: '/videos/help-01-descriptions-es.vtt'
        // },
      ],
      activeVideoId: null,
    }
  },
  mounted: async function () {
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    heigthVideos () {
      return this.mobileVersion ? 160 : 240
    },
    // player () {
    //   return this.$refs.youtube.player
    // },
    // heightViewTabs () {
    //   return this.$refs.containertabs?.clientHeight
    // }
  },
  methods: {
    goToAcademy () {
      window.open(this.urlAcademy, '_blank')
    },
    openWindowYoutube (urlLink) {
      window.open('https://www.youtube.com/watch?v=' + urlLink)
    },
    getVideos: async function () {
      try {
        this.isLoadedData = false
        const response = await getVideos()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          for (let i = 0; i < response.listaVideos.length; i++) {
            response.listaVideos[i].id = i
          }
          this.videoIds = response.listaVideos.map((video, index) => ({
            id: index,
            Titulo: video.Titulo,
            // Src: video.Src,
            // CaptionsSrc: video.CaptionsSrc,
            // DescripcionsSrc: video.DescripcionsSrc,
            // Poster: video.Poster,
            youtubeId: video.IdLink,
            youtubeDescId: video.IdLinkDesc,
          }))
          this.isLoadedData = true
        }
      } catch (error) {
        this.doFeedback()
      } 
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.activeVideoId = null
      this.$emit('toggleDialog')
    },
    downloadManualUsuario () {
      this.$refs.downloadManualBtn.click()
    },
    downloadManualDistribuidor () {
      this.$refs.downloadManualDistribuidorBtn.click()
    },
    openManualUsuario () {
      window.open(window.location.origin + '/files/EdasNEO-Manual.pdf')
    },
    openManualDistribuidor () {
      window.open(window.location.origin + '/files/EdasNEO-Manual-Distribuidor.pdf')
    },
    // playVideo () {
    //   this.player.playVideo()
    // },
    downloadLicense () {
      this.$refs.downloadLicense.click()
    },
    showBtnLicense (tab, event) {
      if (parseInt(tab.index) === 3) {
        this.btnLicense = true
      } else {
        this.btnLicense = false
      }
    }
  }
}
</script>

<style scoped>
.el-tab-pane {
  overflow-x: hidden;
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>

